export enum IntervalType {
  DAILY = 'DAILY',
  INTERVAL = 'INTERVAL',
  WEEKDAYS = 'WEEKDAYS',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
}
